
import { decode as base64_decode, encode as base64_encode } from 'base-64';
import { postApi, baseURL } from '../components/Utility'
import {
    action,
    makeObservable,
    observable,
} from 'mobx';


class TaxiViolationStore {
    sensorReport = []
    total = 0
    loading = false
    rootStore

    constructor(rootStore) {
        makeObservable(this, {
            sensorReport: observable,
            total: observable,
            loading: observable,
            loadData: action,
            releaseCmd: action,

        });
        this.rootStore = rootStore;

    }

    async loadData({ offset, limit, companyId, vehicleId, fromDate, toDate, pageNo }) {
        this.loading = true;

        var postData = { "companyId": companyId, "vehicleId": vehicleId, "fromDate": fromDate, "toDate": toDate, "offset": offset, "limit": limit, "page": pageNo }
        const base64Input = await base64_encode(JSON.stringify(postData));
        var response = await postApi.getClient().post("index.php?c=report&a=taxiViolationReport", "postData=" + base64Input);

        this.sensorReport = response?.data?.data?.taxiViolationReport

        this.total = parseInt(response?.data?.data?.TotalCount);
        this.loading = false;
    }

    async exportExcel(getData) {
        console.log("getData", getData);
        let lang = "english";
        window.location.href =
            baseURL +
            "index.php?c=report&a=exportTaxiViolationReportexcel&cid=" +
            getData.companyId +
            "&vid=" +
            getData.vehicleId +
            // "&int="+
            // getData.interval+
            "&fD=" +
            getData.fromDate +
            "&tD=" +
            getData.toDate +
            "&colList=" +
            getData.colList +
            "&language=" +
            lang;
    }

    async exportpdf(getData) {
        let lang = "english";
        window.location.href =
            baseURL +
            "index.php?c=report&a=exportTaxiViolationReportpdf&cid=" +
            getData.companyId +
            "&vid=" +
            getData.vehicleId +
            // "&int="+
            // getData.interval+
            "&fD=" +
            getData.fromDate +
            "&tD=" +
            getData.toDate +
            "&colList=" +
            getData.colList +
            "&language=" +
            lang;
    }

    async releaseCmd(data) {
        const base64Input = await base64_encode(JSON.stringify(data));
        var response = await postApi.getClient().post("index.php?c=report&a=releaseCmd", "postData=" + base64Input);

        return response.data;
    }


}

export default TaxiViolationStore;
